export default "__VITE_ASSET__aG_NpHfx__"